import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Header from '../../component/common/header/header';
import Footer from '../../component/common/footer/footer';

function goBack() {
  window.history.go(-1);
}

const PublicViewLayout = ({ children, embed = false }) => (
  <div className="page-wrapper">
    <div className="page-body-wrapper">
      <Container fluid className="product-wrapper">
        {!embed && <Header mode="inline" />}
        <Row>
          <Col xs="0" sm="1" className="page-sidebar">
            {embed && <div className="mobile-sidebar">
              <label className="switch ml-3">
                <i className="icofont icofont-rounded-double-left font-primary"
                  style={{ fontSize: '24px', cursor: 'pointer' }} onClick={goBack} />
              </label>
            </div>}
          </Col>
          <Col xs="12" sm="10">
            <Card>
              <CardBody>{children}</CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
    {!embed && <Footer />}
  </div>
);

export default PublicViewLayout;
